import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import { throttle } from 'lodash';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { FormGroup, InputGroup, Button, ControlLabel } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { searchOpportunity } from '../search-form/search-form-actions';
import MoneyDisplay from '../money-display';
import styles from './styles.css';

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

class OpportunitySelector extends Component {
  constructor() {
    super();
    this.state = {
      value: '',
      suggestions: [],
      loading: false,
      selectedValue: null,
    };
    this.onSuggestionsFetchRequested = throttle(this.onSuggestionsFetchRequested, 500, { leading: false }).bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.renderSectionTitle = this.renderSectionTitle.bind(this);
    this.getSectionSuggestions = this.getSectionSuggestions.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onChange = this.onChange.bind(this);
    this.clearSelected = this.clearSelected.bind(this);
    this.forceFocus = this.forceFocus.bind(this);
  }

  onChange(event, { newValue }) {
    this.setState({
      value: newValue,
    });
  }


  onSuggestionsFetchRequested({ value }) {
    this.setState({ loading: true, suggestions: [], selectedValue: null });
    const p = new Promise((resolve, reject) => {
      const escapedValue = escapeRegexCharacters(value.trim());
      if (escapedValue && escapedValue.length >= 3) {
        this.props.dispatch(searchOpportunity({ ...this.props.query, q: escapedValue }))
          .then(
            (results) => {
              const matched = escapedValue.match(/[0-9]{11}|[a-zA-Z0-9]{15}|[a-zA-Z0-9]{18}|[a-zA-Z0-9\\-]{36}/);
              const isId = matched && matched !== null && matched !== undefined;
              const hasResults = results && results.length > 0;

              const mainResults = [];

              if (hasResults) {
                mainResults.push({
                  // title: 'Opportunities',
                  suggestions: results,
                });
              } else if (!isId) {
                mainResults.push({
                  suggestions: [{
                    isEmpty: true,
                    name: 'no results found',
                  }],
                });
              }
              if (isId && !hasResults) {
                mainResults.push({
                  // title: 'Opportunity ID',
                  suggestions: [{
                    name: escapedValue,
                    value: escapedValue,
                    opportunity_id: escapedValue,
                    is_id: true,
                  }],
                });
              }
              resolve(mainResults);
            },
            (e) => {
              reject(e);
            },
          );
      } else {
        resolve([{
          suggestions: [{
            isEmpty: true,
            name: escapedValue.length === 0 ? 'type something to search' : 'continue typing to search...',
          }],
        }]);
      }
    });
    p.then(
      (suggestions) => {
        this.setState({ loading: false, suggestions });
      },
      () => {
        this.setState({ loading: true, suggestions: [] });
      },
    );
    return p;
  }

  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] });
  }

  onSuggestionSelected(event, { suggestion }) {
    if (!suggestion.isEmpty) {
      this.setState({ selectedValue: suggestion, value: suggestion.name }, () => {
        this.props.onSelect(suggestion.opportunity_id);
      });
    }
    if (this.fieldEl && this.fieldEl.input) {
      this.fieldEl.input.blur();
    }
  }

  getSuggestionValue(suggestion) {
    if (suggestion.isEmpty) {
      return '';
    }
    return suggestion.name;
  }

  getSectionSuggestions(section) {
    return section.suggestions;
  }

  clearSelected() {
    this.setState({
      selectedValue: null,
      value: '',
    }, () => {
      this.forceFocus();
      this.props.onSelect(null);
    });
  }

  forceFocus() {
    if (this.fieldEl && this.fieldEl.input) {
      this.fieldEl.input.focus();
    }
  }

  renderSuggestion(suggestion, { query }) {
    const { name } = suggestion;
    if (suggestion.isEmpty) {
      return (
        <a href="" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} style={{ cursor: 'not-allowed' }}>
          <em className="text-muted">{suggestion.name}</em>
        </a>
      );
    }
    const matches = match(name, query);
    const parts = parse(name, matches).map((part, id) => ({ ...part, id }));
    return (
      <a href="" onClick={(e) => { e.preventDefault(); }}>
        <div className="clearfix">
          <div className="pull-left" style={{ paddingRight: '15px' }}>
            <span className={suggestion.is_id ? styles.idTag : ''}>
              {parts.map((part) => {
                const className = part.highlight ? styles.tagHighlight : null;
                return (
                  <span className={className} key={part.id}>
                    {part.text}
                  </span>
                );
              })}
            </span>
          </div>
          {!suggestion.is_id &&
            <div className="pull-right text-right">
              <span className="label label-default"><MoneyDisplay value={suggestion.amount} abbreviated precision={2} /></span>
            </div>
          }
        </div>
      </a>
    );
  }
  renderSectionTitle(section) {
    return section.title ? `${section.title}:` : null;
  }

  render() {
    const {
      value, suggestions, loading,
      selectedValue,
    } = this.state;
    const { disabled } = this.props;
    const hasSelected = selectedValue !== null;

    const inputProps = {
      placeholder: 'search by name or ID...',
      value,
      className: 'form-control',
      onChange: this.onChange,
      disabled: disabled || hasSelected,
    };
    const theme = {
      container: styles.autocomplete,
      suggestionsContainer: `dropdown open ${styles.suggestionsContainer}`,
      sectionContainer: `dropdown-menu ${styles.sectionContainer}`,
      suggestionsList: `dropdown-menu ${styles.suggestionsList}`,
      sectionTitle: 'dropdown-header',
      suggestion: '',
      suggestionFocused: 'active',
    };
    let icon = 'search';
    if (loading) {
      icon = 'spinner';
    } else if (hasSelected) {
      icon = 'times-circle';
    }

    return (
      <div>
        <FormGroup>
          <ControlLabel>Opportunity:</ControlLabel>
          <div className={styles.autocompleteWrapper}>
            <InputGroup>
              <Autosuggest
                theme={theme}
                multiSection
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                renderSectionTitle={this.renderSectionTitle}
                getSectionSuggestions={this.getSectionSuggestions}
                inputProps={inputProps}
                shouldRenderSuggestions={() => true}
                onSuggestionSelected={this.onSuggestionSelected}
                ref={(input) => { this.fieldEl = input; }}
              />
              <InputGroup.Addon>
                <Button
                  bsStyle="link"
                  disabled={(loading || disabled)}
                  onClick={hasSelected ? this.clearSelected : this.forceFocus}
                >
                  <Fa className={(hasSelected ? '' : 'text-muted')} name={icon} spin={loading} />
                </Button>
              </InputGroup.Addon>
            </InputGroup>
          </div>
        </FormGroup>
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

OpportunitySelector.propTypes = {
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  query: PropTypes.shape({}),
};
OpportunitySelector.defaultProps = {
  disabled: false,
  onSelect: () => {},
  query: {},
};


export default connect(mapStateToProps)(OpportunitySelector);
